import { render } from "./CoverSingleArtist.vue?vue&type=template&id=1f5751df"
import script from "./CoverSingleArtist.vue?vue&type=script&lang=js"
export * from "./CoverSingleArtist.vue?vue&type=script&lang=js"

import "./CoverSingleArtist.vue?vue&type=style&index=0&id=1f5751df&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__